/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import ExpPoints from '../expPoints/components/ExpPoints';
import Level from '../levels/components/Level';

export default class UserGamificationInfos extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { user } = this.attrs;

		return (
			<div className="UserGamificationInfos">
				<Level user={user} />
				<ExpPoints user={user} />
			</div>
		);
	}
}
